module.exports = __webpack_public_path__ + "static/20-2-29f665c684b1d05d38485f3616985ec2.jpg";